import React from "react";

import "./styles.scss";

type Option = {
  label: string;
  value: string | number;
};

type OptionGroup = {
  label: string;
  options: Option[];
};

type SelectProps = {
  label?: string;
  name: string;
  value: string | number | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  options?: Option[];
  /** Optional role/category groupings (rendered as <optgroup>). */
  groups?: OptionGroup[];
  isShowPlaceHolder?: boolean;
  infoText?: string;
};

const Select: React.FC<SelectProps> = ({
  label,
  name,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  className = "",
  placeholder = "Select...",
  options = [],
  groups,
  isShowPlaceHolder = true,
  infoText,
}) => {
  const hasGroups = Array.isArray(groups) && groups.length > 0;

  return (
    <div className={`${className} custom-input relative`}>
      {label && (
        <label htmlFor={name} className="custom-input__label">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value ?? ""}
        onChange={onChange as any}
        required={required}
        disabled={disabled}
        className={`custom-input__container custom-input__height ${error ? "border-red-500" : ""}`}
      >
        {isShowPlaceHolder && <option value="">{placeholder}</option>}
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
        {hasGroups
          ? groups!.map(group => (
              <optgroup key={group.label} label={group.label}>
                {group.options.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </optgroup>
            ))
          : null}
      </select>
      {infoText && (
        <div className="text-[12px] text-gray-500 mt-1">{infoText}</div>
      )}
      {error && <div className="text-red-500 text-sm mt-1">{error}</div>}
    </div>
  );
};

export default Select;
export type { Option as SelectOption, OptionGroup as SelectOptionGroup };
